module.exports = __webpack_public_path__ + "static/media/30.fb1344e2.mp3";